<template>
  <focus-trap v-model="trapActive">
    <b-modal ref="modal"
             v-bind="bindReferences"
             v-on="$listeners">
      <slot></slot>
    </b-modal>
  </focus-trap>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue'

export default {
  name: 'base-modal',

  components: {
    FocusTrap
  },

  computed: {
    /**
     * Taking all attributes/properties passed into <base-modal>, combining them into a single object, and passing them into the <b-modal> child component instead of have to do it explicitly for each one.
     * NOTE: v-model is not supported using this method: https://github.com/vuejs/vue/issues/6216
     */
    bindReferences () {
      return { ...this.$props, ...this.$attrs }
    },

    trapActive () {
      return this.$refs.modal ? this.$refs.modal.visible : false // $refs do not get set until after the component is rendered so we need to have a default upon initialization.
    }
  }
}
</script>
